export default {
  props: {
    collapsed: {
      type: Boolean,
      default: true
    },
    autoExpand: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      internalCollapsed: this.collapsed
    }
  },
  methods: {
    objectHasValuesWithData(objectToTest) {
      const keys = Object.keys(objectToTest)
      for (let i = 0; i < keys.length; ++i) {
        const key = keys[i]
        if (objectToTest[key]) {
          return true
        }
      }

      return false
    },
    autoExpandIfHasData () {
      if (this.$v && this.$v.$invalid) {
        this.internalCollapsed = false
      }

      // we only ever want to force the section open, never close it just because data is
      // missing in case we've forced it open manually by setting the collapsed prop to false
      this.expandIfHasData(this.value)
    },
    expandIfHasData (value) {
      if (this.objectHasValuesWithData(value)) {
        this.internalCollapsed = false
      }
    },
    setToCorrectCollapseState(value) {
      this.internalCollapsed = !this.objectHasValuesWithData(value)
    }
  },
  created() {
    this.autoExpandIfHasData()
  },
  watch: {
    value (newValue) {
      this.autoExpandIfHasData()
    }
  }
}
